import { render, staticRenderFns } from "./StatusUpdate.vue?vue&type=template&id=6c1667c0"
import script from "./StatusUpdate.vue?vue&type=script&lang=js"
export * from "./StatusUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports